import { Container } from '@/types'
import { createContext, Context } from 'react'
import { ListingGenericContext } from './ListingGenericContext'

interface ContainerListContextProps extends ListingGenericContext<Container> {}

export const ContainerListContext: Context<ContainerListContextProps> = createContext(
  {} as ContainerListContextProps,
)
